const AlertIcon = ({ size = 140, ...props }) => (
  <svg width={size} height={size} viewBox="0 0 140 141" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="70" cy="70.5" r="70" fill="#F65F5F" fillOpacity="0.12" />
    <mask
      id="mask0_22_3688"
      mask-type="luminance" 
      maskUnits="userSpaceOnUse"
      x="36"
      y="41"
      width="68"
      height="60"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M69.9999 44.3335L39.1227 97.6668H100.877L69.9999 44.3335Z"
        fill="white"
        stroke="white"
        strokeWidth="5.61404"
        strokeLinecap="round"
      />
      <path d="M70 86.439V87.8426M70 63.9829L70.0112 78.018" stroke="black" strokeWidth="5.61404" strokeLinecap="round" />
    </mask>
    <g mask="url(#mask0_22_3688)">
      <path d="M36.3159 37.3164H103.684V104.685H36.3159V37.3164Z" fill="#FF3418" />
    </g>
  </svg>
);

export default AlertIcon;
